module.exports = __webpack_public_path__ + "static/media/VccCard.d5f38dc1.webp";